import { render, staticRenderFns } from "./CreateProjectAddressSearch.vue?vue&type=template&id=a5589a02&scoped=true&lang=pug&"
import script from "./CreateProjectAddressSearch.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectAddressSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProjectAddressSearch.vue?vue&type=style&index=0&id=a5589a02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5589a02",
  null
  
)

export default component.exports